import { LoadingOutlined } from "@ant-design/icons";

export function LoadingIcon() {
  return <LoadingOutlined />;
}
